module.exports = __webpack_public_path__ + "static/img/description-raan-phasing-example-2.9beedcf.png";